module.exports = __webpack_public_path__ + "front/img/exhibition.6ba66891.jpg";